import { Card, Table, Row, Typography, Button, Spin, message, Col, Switch, Tooltip, Modal, Popconfirm } from "antd";
import { useEffect, useState } from "react";
import { useMediaQuery } from "react-responsive";
import HTTPClient from "../../utils/HTTPClient";
import { useNavigate, useSearchParams } from "react-router-dom";
import moment from "moment/moment";
import { CalendarOutlined, DeleteOutlined, PlusCircleOutlined, EditOutlined, CheckCircleOutlined, UserOutlined } from "@ant-design/icons";
import { useTranslation } from "react-i18next";
import styled from 'styled-components';

const AB_CRM = () => {
    const navigate = useNavigate();
    const [crmData, setCrmData] = useState(null);
    const [loading, setLoading] = useState(false);
    const { t } = useTranslation();

    const fetch = async () => {
        setLoading(true);
        let res = null;
        try {
            res = await HTTPClient.get("/ab_crm/");
        } catch (e) {
            if (e.response.status === 404) {
                setCrmData(null);
            }
            if (e.response.status === 402) {
                navigate("/home");
            }
        }
        if (res) {
            setCrmData(res.data);
        }
        setLoading(false);
    };

    useEffect(() => {
        fetch();
    }, []);

    const activateCRM = async () => {
        setLoading(true);
        try {
            const response = await HTTPClient.post(`/ab_crm/activate`);
            fetch();
            message.success(response.data.message);
        } catch (e) {
            message.error(e.response.data.message);
        }
        setLoading(false);
    }

    const loginCRM = async () => {
        setLoading(true);
        const response = await HTTPClient.post(`/ab_crm/auth`);
        window.open(response.data, "_blank", "noopener,noreferrer");
        setLoading(false);
    };

    const isLargeScreen = useMediaQuery({
        query: "(min-width: 771px)",
    });

    const noCRM = <>
        <Row style={{ boxShadow: "0px 4px 4px rgba(0, 0, 0, 0.25)", backgroundColor: "white", width: isLargeScreen ? "40%" : "100%", height: "250px", display: "flex", alignItems: "center", borderRadius: "27px", justifyContent: "center" }}>
            <Button
                type="primary"
                onClick={() => activateCRM()}
                icon={< CheckCircleOutlined />}
                style={{ borderRadius: "30px", width: "60%", height: "50%" }}
            >
                {t("ab_crm.no_crm.activate")}
            </Button>
        </Row>
    </>

    const CRM = <>
        <Row style={{ boxShadow: "0px 4px 4px rgba(0, 0, 0, 0.25)", backgroundColor: "white", width: isLargeScreen ? "40%" : "100%", height: "250px", display: "flex", alignItems: "center", borderRadius: "27px", justifyContent: "center" }}>
            <Button
                type="primary"
                onClick={() => loginCRM()}
                icon={< UserOutlined />}
                style={{ borderRadius: "30px", width: "60%", height: "50%" }}
            >
                {t("ab_crm.crm.login")}
            </Button>
        </Row>
    </>

    const renderComponent = () => {
        if (loading) {
            return (
                <div
                    style={{
                        width: "100%",
                        minHeight: "20vh",
                        overflow: "auto",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                    }}>
                    <Spin />
                </div>
            )
        }
        if (!crmData) {
            return noCRM;
        }
        return CRM;
    }

    return (<>
        <Row style={{ backgroundColor: "white", width: "100%", height: isLargeScreen ? "134px" : "180px", padding: "27px 34px" }}>
            <Row>
                <Typography.Text style={{ fontSize: "27px", fontWeight: "bold" }}>
                    {t("ab_crm.title")}
                </Typography.Text>
            </Row>
            <Row style={{ width: "100%", marginTop: "10px" }}>
                <Typography.Text style={{ fontSize: "20px" }}>{t("ab_crm.subtitle")}</Typography.Text>
            </Row>
        </Row>
        <Row style={{ padding: isLargeScreen ? "27px 34px" : "10px 10px" }}>
            {renderComponent()}
        </Row >

    </>
    );
};

export { AB_CRM };
